<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td data-th="Název">
            {{ entity.name }}
        </td>
        <td data-th="Kód">
            {{ entity.code }}
        </td>
        <td data-th="Skupina zařízení">
            {{ entity.name_device_group }}
        </td>
        <td data-th="Extra tracky">
            <img class="is_set" src="../../../assets/images/is-set.svg" :alt="$gettext('Ano')"
                 v-if="entity.allow_extra_tracks"/>
        </td>
        <td data-th="Počet zařízení">
            {{ entity.device_count }}
        </td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
        <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                    v-if="$_deleteActionAllowed"
                    class="btn btn_action btn_delete"
                    :title="'Smazat' | translate"
                    @click.prevent.stop="emitDeleteDeviceType">
                    <translate class="translate">Smazat</translate>
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
    name: "DeviceTypeRow",
    mixins: [rowActions],
    props: {
        entity: Object,
    },
    data() {
        return {
            moduleName: 'deviceTypes',
            detailPageRouteName: 'deviceTypeDetail',
        }
    },
    methods: {
        emitDeleteDeviceType() {
            this.$emit('deleteDeviceType', String(this.entity.id))
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/DeviceTypeRow.vue